module.exports = __webpack_public_path__ + "img/cwm-logo-fr@legacy.7e4e04aa.svg";